import React from 'react';

const TextAnswer = ({ value = '', onChange, disabled, placeholder = "Escriba sus comentarios u observaciones aquí..." }) => {
  const maxLength = 1000;

  return (
    <div className="flex flex-col gap-2 w-full py-2">
      <textarea
        rows={4}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        disabled={disabled}
        maxLength={maxLength}
        placeholder={placeholder}
        className="w-full p-4 border-2 border-slate-200 rounded-xl text-slate-800 focus:outline-none focus:border-blue-600 focus:ring-2 focus:ring-blue-600/20 transition-all text-sm sm:text-base resize-y min-h-[120px]"
      />
      <div className="text-right text-xs text-slate-400 font-medium">
        {value.length} / {maxLength} caracteres
      </div>
    </div>
  );
};

export default TextAnswer;
